import Event from 'Faster/model/Event';
import FasterRequest from 'Faster/network/FasterRequest';

export default class TrackEventRequest implements FasterRequest {
  public readonly method: string = FasterRequest.METHOD_POST;
  private deviceId: string;
  private userId?: string;
  private sessionId: string;
  private events: Event[];

  public constructor(deviceId: string, userId: string, sessionId: string, events: Event[]) {
    this.deviceId = deviceId;
    this.userId = userId;
    this.sessionId = sessionId;
    this.events = events;
  }

  body(): object {
    return {
      deviceId: this.deviceId,
      userId: this.userId,
      sessionId: this.sessionId,
      events: this.events.map((event) => event.toObject()),
    };
  }

  headers(): object {
    return {
      'Content-Type': 'application/json',
    };
  }

  endpoint(): string {
    return '/v1/event';
  }

  query = () => '';
}
